<template>
  <div class="min-h-screen bg-gray-50 p-6">
    <Head title="Gestión de Códigos Postales" />
    
    <div class="max-w-3xl mx-auto bg-white rounded-lg shadow-md overflow-hidden">
      <div class="p-6">
        <h1 class="text-2xl font-bold text-gray-800 mb-6">Gestión de Códigos Postales</h1>
        
        <form @submit.prevent="processAction" class="space-y-6">
          <!-- Radio Buttons -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Acción:</label>
            <div class="space-y-3">
              <label class="flex items-center space-x-3">
                <input style="margin-right:5px;"
                  type="radio" 
                  v-model="form.action" 
                  value="add" 
                  class="h-4 w-4 text-indigo-600 focus:ring-indigo-500" 
                />
                <span class="text-gray-700">Agregar código postal</span>
              </label>
              <label style="margin-top:20px;" class="flex items-center space-x-3">
                <input style="margin-right:5px;"
                  type="radio" 
                  v-model="form.action" 
                  value="delete" 
                  class="h-4 w-4 text-indigo-600 focus:ring-indigo-500" 
                />
                <span class="text-gray-700">Borrar código postal</span>
              </label>
            </div>
          </div>

          <!-- Input Código Postal -->
          <div style="margin-top:50px;">
            <label for="postal_code" class="block text-sm font-medium text-gray-700">
              Código Postal
            </label>
            <input
              id="postal_code"
              v-model="form.postal_code"
              type="text"
              required
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-2 border"
              placeholder="Ej: 28001"
            />
          </div>

          <!-- Botón de Submit -->
          <div style="margin-top:20px;" class="flex justify-end">
            <button
              type="submit"
              class="inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              :disabled="form.processing"
            >
              {{ form.processing ? 'Procesando...' : (form.action === 'add' ? 'Agregar' : 'Eliminar') }}
            </button>
          </div>
        </form>

<div style="margin-top:20px;" class="flex justify-end">
  <a href="/export-postal-codes">
    <button
      type="button"
      class="inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    >
      Exportar a Excel
    </button>
  </a>
</div>


       
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { Head } from '@inertiajs/inertia-vue3'

export default {
  layout: Layout,
  components: { Head },
  data() {
    return {
      form: this.$inertia.form({
        action: 'add',
        postal_code: null
      })
    }
  },
  methods: {
    processAction() {
      if (!this.form.postal_code) {
        alert('Por favor ingrese un código postal válido')
        return
      }

      this.form.post(this.route('postal_codes.store'), {
        preserveScroll: true
      })
    }
  }
}
</script>



<style scoped>
/* Contenedor principal mejorado */
.min-h-screen {
  background-color: #f8fafc;
}

/* Tarjeta del formulario */
.max-w-3xl {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.max-w-3xl:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

/* Título */
.text-2xl {
  color: #1e293b;
  position: relative;
  padding-bottom: 0.5rem;
}

.text-2xl::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 50px;
  height: 3px;
  background-color: #4f46e5;
}

/* Radio buttons personalizados */
input[type="radio"] {
  transition: all 0.2s ease;
}

input[type="radio"]:checked {
  transform: scale(1.1);
}

/* Input de código postal */
input[type="number"] {
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

input[type="number"]:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}

/* Botón de submit */
.bg-indigo-600 {
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  position: relative;
  overflow: hidden;
}

.bg-indigo-600:hover {
  transform: translateY(-1px);
}

.bg-indigo-600:active {
  transform: translateY(0);
}

.bg-indigo-600::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 5px;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0;
  border-radius: 100%;
  transform: scale(1, 1) translate(-50%);
  transform-origin: 50% 50%;
}

.bg-indigo-600:focus:not(:active)::after {
  animation: ripple 0.6s ease-out;
}

@keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5;
  }
  100% {
    transform: scale(20, 20);
    opacity: 0;
  }
}

/* Efecto de carga en el botón */
button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  position: relative;
}

button:disabled::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 16px;
  height: 16px;
  margin: -8px 0 0 -8px;
  border: 2px solid #fff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Responsividad adicional */
@media (max-width: 640px) {
  .p-6 {
    padding: 1.5rem;
  }
  
  .max-w-3xl {
    margin-left: 1rem;
    margin-right: 1rem;
  }
}
</style>